import { useRef } from "react";

// Stable React keys for editable lists of plain values; call drop(i) when removing row i.
export const useRowKeys = (n) => {
  const keys = useRef([]);
  const seq = useRef(0);
  while (keys.current.length < n) keys.current.push(++seq.current);
  if (keys.current.length > n) keys.current.length = n;
  return [keys.current, (i) => keys.current.splice(i, 1)];
};
